import { useGetFundraisingStatusById } from '@/query/queries/fundraising/useGetFundraisingStatusById';

export const useFundraisingStatusById = id => {
  const { data: status } = useGetFundraisingStatusById(id);

  const isParticipating = status?.goal >= 0; // FF created, brand is participating

  return {
    status,
    isParticipating
  };
};
